export const TASK_ADD_NEW = 'TASK_ADD_NEW'
export const TASK_MOVE = 'TASK_MOVE'
export const TASK_UPDATE = 'TASK_UPDATE'
export const INIT_STATES = 'INIT_STATES'

